document.addEventListener('DOMContentLoaded', function () {
  var tabsRoot = document.getElementById('product-tabs');
  if (!tabsRoot) return;

  var allButtons = tabsRoot.querySelectorAll('.product-tabs__btn');
  var allPanels = tabsRoot.querySelectorAll('.product-tabs__panel');

  // Cache panel references pentru performanță
  var panelMap = {};
  allPanels.forEach(function(panel) {
    panelMap[panel.id] = panel;
  });

  function deactivateAll() {
    allButtons.forEach(function(btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
    });

    allPanels.forEach(function(panel) {
      panel.classList.remove('is-active');
    });
  }

  function activateTab(button) {
    deactivateAll();

    button.classList.add('is-active');
    button.setAttribute('aria-selected', 'true');

    // Folosește cache-ul în loc de getElementById
    var targetPanelId = button.getAttribute('aria-controls');
    var targetPanel = panelMap[targetPanelId];
    
    if (targetPanel) {
      targetPanel.classList.add('is-active');
    }
  }

  // Event delegation în loc de addEventListener individual
  tabsRoot.addEventListener('click', function(e) {
    if (e.target.classList.contains('product-tabs__btn')) {
      activateTab(e.target);
    }
  });

  // Keyboard navigation pentru accessibility
  tabsRoot.addEventListener('keydown', function(e) {
    if (!e.target.classList.contains('product-tabs__btn')) return;

    var currentIndex = Array.from(allButtons).indexOf(e.target);
    var nextButton = null;

    switch(e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        nextButton = allButtons[currentIndex + 1] || allButtons[0];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        nextButton = allButtons[currentIndex - 1] || allButtons[allButtons.length - 1];
        break;
      case 'Home':
        e.preventDefault();
        nextButton = allButtons[0];
        break;
      case 'End':
        e.preventDefault();
        nextButton = allButtons[allButtons.length - 1];
        break;
    }

    if (nextButton) {
      nextButton.focus();
      activateTab(nextButton);
    }
  });

  // Activează primul tab cu verificare robustă
  var activeTab = tabsRoot.querySelector('.product-tabs__btn.is-active');
  if (!activeTab && allButtons.length > 0) {
    activateTab(allButtons[0]);
  }
});